var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7,
  _t8,
  _t9,
  _t10,
  _t11,
  _t12,
  _t13,
  _t14;
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.reflect.get.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/esnext.string.replace-all.js";
import "core-js/modules/web.dom-collections.for-each.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import { LitElement, html } from 'lit';
import css from './style.pcss';
import translations from './translations';
import * as dayjs from 'dayjs';
import PreviousIcon from "../../common/images/ic_previous.svg";
import PrevIcon from "../../common/images/ic_prev.svg";
import LastIcon from "../../common/images/ic_last.svg";
import NextIcon from "../../common/images/ic_next.svg";
import SearchMagnifierIcon from "./images/ic_search-magnifier.svg";
var RTLSearch = /*#__PURE__*/function (_LitElement) {
  _inherits(RTLSearch, _LitElement);
  function RTLSearch() {
    var _this;
    _classCallCheck(this, RTLSearch);
    _this = _callSuper(this, RTLSearch);
    _this.language = 'lu';
    _this.query = _this._getUrlParameter('q');
    _this.limit = 20;
    _this.start = 0;
    _this.count = 20;
    _this.currentPage = Number(_this._getUrlParameter('p'));
    if (!_this.currentPage) _this.currentPage = 1;
    _this.location = window.location.origin;
    if (window.rtlsites) {
      _this.language = window.rtlsites.config.language;
    }
    return _this;
  }
  _createClass(RTLSearch, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(RTLSearch.prototype), "connectedCallback", this).call(this);
      this._fetchData();
    }
  }, {
    key: "_sanitizeText",
    value: function _sanitizeText(text) {
      var replace = {
        "&nbsp;": " ",
        "&amp;": "&",
        "&quot;": "\"",
        "&lt;": "<",
        "&gt;": ">"
      };
      Object.keys(replace).forEach(function (key) {
        text = text.replaceAll(key, replace[key]);
      });
      return text;
    }
  }, {
    key: "_getTranslation",
    value: function _getTranslation(key) {
      if (!translations[key]) {
        console.warn(key + ' is not defined in translations.js!');
      } else return translations[key][this.language];
    }
  }, {
    key: "_getUrlParameter",
    value: function _getUrlParameter(name) {
      name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
      var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
      var results = regex.exec(location.search);
      return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }
  }, {
    key: "_fetchData",
    value: function _fetchData() {
      var _this2 = this;
      var q = this._getUrlParameter('q');
      if (q.length < 3) return;
      var start = (this.currentPage - 1) * this.limit;
      this._apiUrl = `${this.location}/api/search/curator?q=${q}&start=${start}&limit=${this.limit}`;

      // console.log(this._apiUrl);

      fetch(this._apiUrl).then(function (resp) {
        return resp.json();
      }).then(function (resp) {
        _this2.data = resp;
        _this2.count = resp.total;
      }).catch(function (error) {
        console.log('ERROR: ' + error.message);
      });
    }
  }, {
    key: "_renderResults",
    value: function _renderResults() {
      var _this3 = this;
      if (!this.data) return;
      var results = this.data.items;
      return html(_t || (_t = _`
            ${0}
        `), results.length > 0 ? html(_t2 || (_t2 = _`
                ${0}
            `), results.map(function (result) {
        return html(_t3 || (_t3 = _`
                    <div class="rtl-search-res">
                        <div class="rtl-search-res__media">
                            ${0}
                        </div>
                        <div class="rtl-search-res__content">
                            ${0}
                            <a href="${0}" class="rtl-search-res__title">${0}</a>
                            <a href="${0}" class="rtl-search-res__link">${0}</a>
                            <div href="${0}" class="rtl-search-res__header">${0}</div>
                            <a href="${0}" class="rtl-search-res__blocklink">${0}</a>

                            <a href="${0}" class="rtl-search-res__date">${0}</a>
                        </div>
                    </div>
                `), result.thumbnail ? html(_t4 || (_t4 = _`<img src="${0}" />`), result.thumbnail) : html(_t5 || (_t5 = _`<div class="rtl-search-res__placeholder"></div>`)), result.kicker ? html(_t6 || (_t6 = _`<a href="${0}" class="rtl-search-res__kicker">${0}</a>`), result.link, result.kicker) : '', result.link, result.title, result.link, result.link, result.link, _this3._sanitizeText(result.header), result.link, result.title, result.link, dayjs(result.date).format('DD/MM/YYYY - HH:mm'));
      })) : html(_t7 || (_t7 = _`
                <div class="rtl-search-res__noresult">${0}</div>
            `), this._getTranslation('noresult')));
    }
  }, {
    key: "_changePage",
    value: function _changePage(p) {
      window.location.href = `${window.location.pathname}?q=${this.query}&p=${p}`;
    }
  }, {
    key: "_renderPager",
    value: function _renderPager() {
      var _this4 = this;
      if (this.count == 0 || this.count <= this.limit) return;
      var pageCount = Math.ceil(this.count / this.limit);
      var pager = [];
      var prevPage = this.currentPage - (this.currentPage > 1 ? 1 : 0);
      var nextPage = this.currentPage + (this.currentPage < pageCount ? 1 : 0);
      pager.push(html(_t8 || (_t8 = _`
            <li
                class="rtl-search-pager__item rtl-search-pager__item--arrow" style="background-image: url('${0}');"
                @click=${0}
            >
            </li>
        `), PreviousIcon, function () {
        return _this4._changePage(1);
      }));
      pager.push(html(_t9 || (_t9 = _`
            <li
                class="rtl-search-pager__item rtl-search-pager__item--arrow" style="background-image: url('${0}');"
                @click=${0}
            >
            </li>
        `), PrevIcon, function () {
        return _this4._changePage(prevPage);
      }));
      var elementsBeforeActive = 3;
      var _loop = function _loop(i) {
        var upperLimit = elementsBeforeActive;
        var lowerLimit = elementsBeforeActive;
        if (_this4.currentPage <= elementsBeforeActive) {
          upperLimit += 1 + elementsBeforeActive - _this4.currentPage;
        }
        if (_this4.currentPage >= pageCount - elementsBeforeActive) {
          lowerLimit += elementsBeforeActive + _this4.currentPage - pageCount;
        }
        if (i < _this4.currentPage - lowerLimit || i > _this4.currentPage + upperLimit) return 1; // continue
        var activeClass = '';
        if (_this4.currentPage === i) activeClass = ' rtl-search-pager__item--active';
        pager.push(html(_t13 || (_t13 = _`<li class="rtl-search-pager__item rtl-search-pager__item--page${0}" @click=${0}>${0}</li>`), activeClass, function () {
          return _this4._changePage(i);
        }, i));
      };
      for (var i = 1; i <= pageCount; i++) {
        if (_loop(i)) continue;
      }
      pager.push(html(_t10 || (_t10 = _`
            <li
                class="rtl-search-pager__item rtl-search-pager__item--arrow" style="background-image: url('${0}');"
                @click=${0}
            >
            </li>
        `), LastIcon, function () {
        return _this4._changePage(nextPage);
      }));
      pager.push(html(_t11 || (_t11 = _`
            <li
                class="rtl-search-pager__item rtl-search-pager__item--arrow" style="background-image: url('${0}');"
                @click=${0}
            >
            </li>
        `), NextIcon, function () {
        return _this4._changePage(pageCount);
      }));
      pager = html(_t12 || (_t12 = _`<ul class="rtl-search-pager">${0}</ul>`), pager);
      return pager;
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;
      return html(_t14 || (_t14 = _`
            <style>${0}</style>
            <div class="rtl-search-container rtl-search--${0}">
                <form id="search-form" onsubmit="return q.value!=''" method="GET">
                    <div class="rtl-search__form rtl-search-form">
                        <div class="rtl-search-form__inner">
                            <div class="rtl-search-form__input">
                                <input class="rtl-search-form__text js-search-query" name="q" type="text" value="${0}" autocapitalize="off" autocomplete="off" autocorrect="off" spellcheck="false" title="Sichen" placeholder="${0}" />
                            </div>
                            <div @click=${0} class="rtl-search-form__btn button-default-co js-search-btn">→</div>
                        </div>
                    </div>
                </form>

                <div class="rtl-search__results">
                    ${0}
                </div>

                <div class="rtl-search__pager">
                    ${0}
                </div>
            </div>
        `), css, this.theme, this.query, this._getTranslation('search-text'), function () {
        return _this5.shadowRoot.getElementById('search-form').submit();
      }, this._renderResults(), this._renderPager());
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        data: {
          type: String
        },
        language: {
          type: String
        },
        currentPage: {
          type: Number
        },
        query: {
          type: String
        }
      };
    }
  }]);
  return RTLSearch;
}(LitElement);
export { RTLSearch as default };
window.customElements.define('rtl-search', RTLSearch);